import { publicApi } from '@/lib/api';

export const trackEvent = (event_type, page = window.location.pathname, meta = {}) => {
    publicApi.track({ event_type, page, meta });
};
